import { render, staticRenderFns } from "./Orthograph.vue?vue&type=template&id=22e95fe8&lang=pug&"
import script from "./Orthograph.vue?vue&type=script&lang=js&"
export * from "./Orthograph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports